// extracted by mini-css-extract-plugin
export default {"primaryColor":"#ed1c24"};